<template>
	<router-view />
</template>

<script lang="ts">
/* eslint-disable vue/multi-word-component-names */
import { defineComponent } from "vue";
export default defineComponent({
	name: "Billing",
	data: () => ({}),
});
</script>
